// common/RDVButton.js
import React from "react";
import styled from "styled-components";
import { settings } from "../data/settings";

// Style du bouton RDV
const Button = styled.button`
  padding: 0.6rem 1.1rem;
  background-color: ${(props) =>
    props.invertColor === true ? "white" : "black"};
  color: ${(props) => (props.invertColor === true ? "black" : "white")};
  font-weight: 400;
  border: none;
  cursor: pointer;
  font-size: 1.1rem;
  transition: background 0.3s;
  text-transform: uppercase;
  white-space: nowrap;
  height: fit-content;
  width: fit-content;

  &:hover {
    background-color: ${(props) =>
      props.invertColor === true ? "#A7A6A6" : "#222"};
  }
`;

// Composant RDVButton
export const RDVButton = ({ invertColor = false }) => {
  const handleClick = () => {
    // Ouvrir Planity dans un nouvel onglet
    window.open(settings?.rdvLink, "_blank");
  };

  return (
    <Button invertColor={invertColor || false} onClick={handleClick}>
      Prendre RDV
    </Button>
  );
};
